<script lang="ts">
  import { mdiFilePdfBox, mdiFileRemoveOutline } from "@mdi/js"
  import InboxActionToggleCell from "../../../../../../../../_shared/_modules/inbox-action-toggle-cell"
  import type { PrintSelectionPreviewRow } from "../../../../../../../../_shared/_logic/print-selection-preview"
  import type {
    PrintSelectionState,
    PrintSelectionValue,
  } from "../../../../_shared/_logic/print-selection-state"

  let {
    row,
    selection,
    disabled = false,
    onChange,
  }: {
    row: PrintSelectionPreviewRow
    selection: PrintSelectionState
    disabled?: boolean
    onChange: (itemId: string, value: PrintSelectionValue) => void
  } = $props()

  const valueFor = (item: PrintSelectionPreviewRow): PrintSelectionValue =>
    selection[item.letter_delivery_batch_item_id] ?? "no"

  const printOptions = (item: PrintSelectionPreviewRow) => [
    {
      value: "yes",
      label: "Ins PDF aufnehmen",
      icon: mdiFilePdfBox,
      disabled: !item.printable,
      tooltipContent: item.printable ? null : item.disabled_reason,
    },
    { value: "no", label: "Nicht aufnehmen", icon: mdiFileRemoveOutline, tone: "neutral" as const },
  ]
</script>

<InboxActionToggleCell
  value={valueFor(row)}
  options={printOptions(row)}
  {disabled}
  ariaLabel={`Druckauswahl für ${row.order_label}`}
  onChange={(next) => onChange(row.letter_delivery_batch_item_id, next as PrintSelectionValue)}
/>
